<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="isRouterAlive&&!$route.meta.keepAlive"/>
  </div>
</template>

<script>
export default {
  provide () {
    return {
      reload: this.reload
    }
  },
  data(){
    return{
      is_mobi:'',
      isRouterAlive: true
    }
  },
  computed:{
    path(){
      return this.$route.path;
    }
  },
  watch:{
    path(){
      if(window.location.href.indexOf('/view_ppt')==-1&&window.location.href.indexOf('/view_video')==-1&&window.location.href.indexOf('/view_data')==-1&&window.location.href.indexOf('/view_pdf')==-1&&window.location.href.indexOf('/map')==-1){
        var token=this.$local.get('token')
        if(token){
          this.$getMyNoticeList()
        }
      }
    }
  },
  methods:{
    handleStorageChange(event) {
      if(event.key === 'userInfo') {
        const newData = JSON.parse(event.newValue);
        const oldData = JSON.parse(event.oldValue);
        if(newData.id&&newData.id!=oldData.id){
          location.reload()
        }
      }
    },
    reload(){//无感刷新
      console.log('====')
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    // 启动预签：递归扫描持久化在 localStorage 的过期 OSS 签名 URL（品牌logo/头像/菜单icon），
    // 批量重签后写回，解决「刷新浏览器后图标裂图」问题（签名仅 2h 有效）。
    // 仅覆盖「常驻 storage 资源」，页面内接口返回的图标由 <signed-image> 兜底重签。
    async preSignStorageOss() {
      const keys = ['userInfo', 'myBrand', 'brand_list', 'menus'];
      const targets = [];
      const roots = {};
      const collect = (storageKey, obj, path) => {
        if (!obj || typeof obj !== 'object') return;
        if (typeof obj === 'string') {
          if (obj.indexOf('oss.jinding.work') !== -1 && this.$isOssExpired(obj)) {
            targets.push({ storageKey, path, bare: this.$stripOssSign(obj) });
          }
          return;
        }
        if (Array.isArray(obj)) {
          obj.forEach((it, i) => collect(storageKey, it, path.concat(i)));
          return;
        }
        for (const k in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, k)) collect(storageKey, obj[k], path.concat(k));
        }
      };
      keys.forEach(k => {
        const v = this.$local.get(k);
        if (v) { roots[k] = v; collect(k, v, []); }
      });
      if (targets.length === 0) return;
      try {
        const freshUrls = await this.$reSignOssBatch(targets.map(t => t.bare));
        let changed = false;
        targets.forEach((t, i) => {
          const fresh = freshUrls[i];
          if (fresh && fresh !== t.bare) {
            const root = roots[t.storageKey];
            let cur = root;
            for (let j = 0; j < t.path.length - 1; j++) cur = cur[t.path[j]];
            cur[t.path[t.path.length - 1]] = fresh;
            changed = true;
          }
        });
        if (changed) keys.forEach(k => { if (roots[k]) this.$local.set(k, roots[k]); });
      } catch (e) {
        console.warn('启动预签失败:', e);
      }
    },
    //判断是pc端还是手机端
    dg(){
      this.is_mobi = navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
      if(this.is_mobi){
        // window.location.href = "手机端"
        this.$store.commit('changeMobi','mobile')
        this.reload()
        console.log('手机端')
      }else{
        // window.location.href = "pc端"
        this.$store.commit('changeMobi','pc')
        this.reload()
        console.log('pc端')
      }
    }
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  created() {
    if(window.location.href.indexOf('/view_ppt')==-1&&window.location.href.indexOf('/view_video')==-1&&window.location.href.indexOf('/view_data')==-1&&window.location.href.indexOf('/view_pdf')==-1&&window.location.href.indexOf('/map')==-1){
      var token=this.$local.get('token')
      if(!token){
        this.$router.replace({
          path:'/login'
        })
      } else {
        // 已登录：启动预签，刷新常驻 storage 内的过期 OSS 签名 URL（异步，不阻塞渲染）
        this.preSignStorageOss();
      }
    }
  }
}
</script>

<style lang="scss">
.el-cascader-panel .el-radio{
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
    top: 10px;
    right: -10px; }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
html,body{
  height: 100%;
  margin:0;
}
input::-webkit-outer-spin-button,

input::-webkit-inner-spin-button {
-webkit-appearance: none;
}
input[type="number"]{
-moz-appearance: textfield;
}
button{
  outline:none;
  border:0;
  cursor:pointer;
}
input[type=checkbox] {
position:static;
}
.el-input-number__decrease:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled),
.el-input-number__increase:hover:not(.is-disabled)~.el-input .el-input__inner:not(.is-disabled) {
  border-color: #FF6B40!important;
}
.el-switch__label.is-active{
  color: #FF6B40!important;
}
.el-date-table td.end-date span, .el-date-table td.start-date span{
  background-color: #FF6B40!important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #FF6B40!important;
  color: #fff!important;
}
.el-pagination.is-background .el-pager li:hover{
  color: #FF6B40!important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover{
  color: #FFFFFF!important;
}
.el-range-editor.is-active, .el-range-editor.is-active:hover{
  border-color:#FF6B40!important;
}
.el-textarea__inner:focus{
  border-color:#FF6B40 !important;
}
.el-input__inner:focus{
  border-color:#FF6B40 !important;
}
/* Element 聚焦时给外层 wrapper 加 .is-focus（特异性 0,3,0），必须显式用 !important 覆盖 */
.el-input.is-focus .el-input__inner{
  border-color:#FF6B40 !important;
}
.el-button--primary{
  border-color:#FF6B40!important;
  background-color:#FF6B40!important;
}
.el-date-table td.today span,.el-button--text{
  color:#FF6B40!important;
}
.el-checkbox__input.is-checked+.el-checkbox__label{
  color:#FF6B40!important;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  border-color:#FF6B40!important;
  background-color:#FF6B40!important;
}
.el-checkbox__input.is-focus .el-checkbox__inner{
  border-color:#FF6B40!important;
}
.el-button:hover{
  background:rgba(255,107,64,0.07)!important;
  border-color:#FF6B40!important;
  color:#FF6B40!important;
}
.el-message-box__headerbtn .el-message-box__close:hover{
  color:#FF6B40!important;
}
.el-select .el-input.is-focus .el-input__inner{
  border:1px solid #FF6B40;
}
.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{
  border:1px solid #FF6B40;
}
.el-select .el-input__inner:focus{
  border-color:#FF6B40 !important;
}
.el-select-dropdown__item.selected{
  color:#FF6B40!important;
}
.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path,.el-cascader__suggestion-item.is-checked{
  color:#FF6B40!important;
}
.el-radio__input.is-checked .el-radio__inner{
  border-color:#FF6B40!important;
  background-color:#FF6B40!important;
}
.el-radio__input .el-radio__inner:hover{
  border-color:#FF6B40!important;
}
.el-radio__input.is-checked+.el-radio__label,.el-month-table td.today .cell{
  color:#FF6B40!important
}
.el-picker-panel__footer .el-button--text.el-picker-panel__link-btn{
  display: none!important;
}
.el-month-table td.end-date .cell, .el-month-table td.start-date .cell{
  background-color:#FF6B40!important;
}
.el-month-table td.today.end-date .cell, .el-month-table td.today.start-date .cell{
  color:#FFFFFF!important
}

.highlight-date {
  color: #5daf34!important;
  transition:0.3s;
  &:hover {
    background-color: #67c23a !important;
    color:#ffffff!important;
    border-radius:4px!important;
  }
}
</style>
